/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiProjectFinancialSummariesChangeStatusOfProjectFinancialSummaryPost } from '../fn/project-financial-summaries/api-project-financial-summaries-change-status-of-project-financial-summary-post';
import { ApiProjectFinancialSummariesChangeStatusOfProjectFinancialSummaryPost$Params } from '../fn/project-financial-summaries/api-project-financial-summaries-change-status-of-project-financial-summary-post';
import { apiProjectFinancialSummariesChangeStatusOfProjectFinancialSummaryPost$Plain } from '../fn/project-financial-summaries/api-project-financial-summaries-change-status-of-project-financial-summary-post-plain';
import { ApiProjectFinancialSummariesChangeStatusOfProjectFinancialSummaryPost$Plain$Params } from '../fn/project-financial-summaries/api-project-financial-summaries-change-status-of-project-financial-summary-post-plain';
import { apiProjectFinancialSummariesCreateProjectFinancialSummaryPost } from '../fn/project-financial-summaries/api-project-financial-summaries-create-project-financial-summary-post';
import { ApiProjectFinancialSummariesCreateProjectFinancialSummaryPost$Params } from '../fn/project-financial-summaries/api-project-financial-summaries-create-project-financial-summary-post';
import { apiProjectFinancialSummariesCreateProjectFinancialSummaryPost$Plain } from '../fn/project-financial-summaries/api-project-financial-summaries-create-project-financial-summary-post-plain';
import { ApiProjectFinancialSummariesCreateProjectFinancialSummaryPost$Plain$Params } from '../fn/project-financial-summaries/api-project-financial-summaries-create-project-financial-summary-post-plain';
import { apiProjectFinancialSummariesDeleteProjectFinancialSummaryDelete } from '../fn/project-financial-summaries/api-project-financial-summaries-delete-project-financial-summary-delete';
import { ApiProjectFinancialSummariesDeleteProjectFinancialSummaryDelete$Params } from '../fn/project-financial-summaries/api-project-financial-summaries-delete-project-financial-summary-delete';
import { apiProjectFinancialSummariesDeleteProjectFinancialSummaryDelete$Plain } from '../fn/project-financial-summaries/api-project-financial-summaries-delete-project-financial-summary-delete-plain';
import { ApiProjectFinancialSummariesDeleteProjectFinancialSummaryDelete$Plain$Params } from '../fn/project-financial-summaries/api-project-financial-summaries-delete-project-financial-summary-delete-plain';
import { apiProjectFinancialSummariesGetPreviousPaymentsPost } from '../fn/project-financial-summaries/api-project-financial-summaries-get-previous-payments-post';
import { ApiProjectFinancialSummariesGetPreviousPaymentsPost$Params } from '../fn/project-financial-summaries/api-project-financial-summaries-get-previous-payments-post';
import { apiProjectFinancialSummariesGetPreviousPaymentsPost$Plain } from '../fn/project-financial-summaries/api-project-financial-summaries-get-previous-payments-post-plain';
import { ApiProjectFinancialSummariesGetPreviousPaymentsPost$Plain$Params } from '../fn/project-financial-summaries/api-project-financial-summaries-get-previous-payments-post-plain';
import { apiProjectFinancialSummariesGetProjectFinancialSummariesPost } from '../fn/project-financial-summaries/api-project-financial-summaries-get-project-financial-summaries-post';
import { ApiProjectFinancialSummariesGetProjectFinancialSummariesPost$Params } from '../fn/project-financial-summaries/api-project-financial-summaries-get-project-financial-summaries-post';
import { apiProjectFinancialSummariesGetProjectFinancialSummariesPost$Plain } from '../fn/project-financial-summaries/api-project-financial-summaries-get-project-financial-summaries-post-plain';
import { ApiProjectFinancialSummariesGetProjectFinancialSummariesPost$Plain$Params } from '../fn/project-financial-summaries/api-project-financial-summaries-get-project-financial-summaries-post-plain';
import { apiProjectFinancialSummariesGetProjectFinancialSummaryPost } from '../fn/project-financial-summaries/api-project-financial-summaries-get-project-financial-summary-post';
import { ApiProjectFinancialSummariesGetProjectFinancialSummaryPost$Params } from '../fn/project-financial-summaries/api-project-financial-summaries-get-project-financial-summary-post';
import { apiProjectFinancialSummariesGetProjectFinancialSummaryPost$Plain } from '../fn/project-financial-summaries/api-project-financial-summaries-get-project-financial-summary-post-plain';
import { ApiProjectFinancialSummariesGetProjectFinancialSummaryPost$Plain$Params } from '../fn/project-financial-summaries/api-project-financial-summaries-get-project-financial-summary-post-plain';
import { apiProjectFinancialSummariesUpdateProjectFinancialSummaryPatch } from '../fn/project-financial-summaries/api-project-financial-summaries-update-project-financial-summary-patch';
import { ApiProjectFinancialSummariesUpdateProjectFinancialSummaryPatch$Params } from '../fn/project-financial-summaries/api-project-financial-summaries-update-project-financial-summary-patch';
import { apiProjectFinancialSummariesUpdateProjectFinancialSummaryPatch$Plain } from '../fn/project-financial-summaries/api-project-financial-summaries-update-project-financial-summary-patch-plain';
import { ApiProjectFinancialSummariesUpdateProjectFinancialSummaryPatch$Plain$Params } from '../fn/project-financial-summaries/api-project-financial-summaries-update-project-financial-summary-patch-plain';
import { ChangeStatusOfProjectFinancialSummaryCommandResult } from '../models/change-status-of-project-financial-summary-command-result';
import { CreateProjectFinancialSummaryCommandResult } from '../models/create-project-financial-summary-command-result';
import { DeleteProjectFinancialSummaryCommandResult } from '../models/delete-project-financial-summary-command-result';
import { GetPreviousPaymentsQueryResult } from '../models/get-previous-payments-query-result';
import { GetProjectFinancialSummariesQueryResult } from '../models/get-project-financial-summaries-query-result';
import { GetProjectFinancialSummaryQueryResult } from '../models/get-project-financial-summary-query-result';
import { UpdateProjectFinancialSummaryCommandResult } from '../models/update-project-financial-summary-command-result';

@Injectable({ providedIn: 'root' })
export class ProjectFinancialSummariesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiProjectFinancialSummariesGetProjectFinancialSummaryPost()` */
  static readonly ApiProjectFinancialSummariesGetProjectFinancialSummaryPostPath = '/api/ProjectFinancialSummaries/GetProjectFinancialSummary';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectFinancialSummariesGetProjectFinancialSummaryPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectFinancialSummariesGetProjectFinancialSummaryPost$Plain$Response(params?: ApiProjectFinancialSummariesGetProjectFinancialSummaryPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectFinancialSummaryQueryResult>> {
    return apiProjectFinancialSummariesGetProjectFinancialSummaryPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectFinancialSummariesGetProjectFinancialSummaryPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectFinancialSummariesGetProjectFinancialSummaryPost$Plain(params?: ApiProjectFinancialSummariesGetProjectFinancialSummaryPost$Plain$Params, context?: HttpContext): Observable<GetProjectFinancialSummaryQueryResult> {
    return this.apiProjectFinancialSummariesGetProjectFinancialSummaryPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetProjectFinancialSummaryQueryResult>): GetProjectFinancialSummaryQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectFinancialSummariesGetProjectFinancialSummaryPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectFinancialSummariesGetProjectFinancialSummaryPost$Response(params?: ApiProjectFinancialSummariesGetProjectFinancialSummaryPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectFinancialSummaryQueryResult>> {
    return apiProjectFinancialSummariesGetProjectFinancialSummaryPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectFinancialSummariesGetProjectFinancialSummaryPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectFinancialSummariesGetProjectFinancialSummaryPost(params?: ApiProjectFinancialSummariesGetProjectFinancialSummaryPost$Params, context?: HttpContext): Observable<GetProjectFinancialSummaryQueryResult> {
    return this.apiProjectFinancialSummariesGetProjectFinancialSummaryPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetProjectFinancialSummaryQueryResult>): GetProjectFinancialSummaryQueryResult => r.body)
    );
  }

  /** Path part for operation `apiProjectFinancialSummariesGetProjectFinancialSummariesPost()` */
  static readonly ApiProjectFinancialSummariesGetProjectFinancialSummariesPostPath = '/api/ProjectFinancialSummaries/GetProjectFinancialSummaries';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectFinancialSummariesGetProjectFinancialSummariesPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectFinancialSummariesGetProjectFinancialSummariesPost$Plain$Response(params?: ApiProjectFinancialSummariesGetProjectFinancialSummariesPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectFinancialSummariesQueryResult>> {
    return apiProjectFinancialSummariesGetProjectFinancialSummariesPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectFinancialSummariesGetProjectFinancialSummariesPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectFinancialSummariesGetProjectFinancialSummariesPost$Plain(params?: ApiProjectFinancialSummariesGetProjectFinancialSummariesPost$Plain$Params, context?: HttpContext): Observable<GetProjectFinancialSummariesQueryResult> {
    return this.apiProjectFinancialSummariesGetProjectFinancialSummariesPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetProjectFinancialSummariesQueryResult>): GetProjectFinancialSummariesQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectFinancialSummariesGetProjectFinancialSummariesPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectFinancialSummariesGetProjectFinancialSummariesPost$Response(params?: ApiProjectFinancialSummariesGetProjectFinancialSummariesPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectFinancialSummariesQueryResult>> {
    return apiProjectFinancialSummariesGetProjectFinancialSummariesPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectFinancialSummariesGetProjectFinancialSummariesPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectFinancialSummariesGetProjectFinancialSummariesPost(params?: ApiProjectFinancialSummariesGetProjectFinancialSummariesPost$Params, context?: HttpContext): Observable<GetProjectFinancialSummariesQueryResult> {
    return this.apiProjectFinancialSummariesGetProjectFinancialSummariesPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetProjectFinancialSummariesQueryResult>): GetProjectFinancialSummariesQueryResult => r.body)
    );
  }

  /** Path part for operation `apiProjectFinancialSummariesGetPreviousPaymentsPost()` */
  static readonly ApiProjectFinancialSummariesGetPreviousPaymentsPostPath = '/api/ProjectFinancialSummaries/GetPreviousPayments';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectFinancialSummariesGetPreviousPaymentsPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectFinancialSummariesGetPreviousPaymentsPost$Plain$Response(params?: ApiProjectFinancialSummariesGetPreviousPaymentsPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetPreviousPaymentsQueryResult>> {
    return apiProjectFinancialSummariesGetPreviousPaymentsPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectFinancialSummariesGetPreviousPaymentsPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectFinancialSummariesGetPreviousPaymentsPost$Plain(params?: ApiProjectFinancialSummariesGetPreviousPaymentsPost$Plain$Params, context?: HttpContext): Observable<GetPreviousPaymentsQueryResult> {
    return this.apiProjectFinancialSummariesGetPreviousPaymentsPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetPreviousPaymentsQueryResult>): GetPreviousPaymentsQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectFinancialSummariesGetPreviousPaymentsPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectFinancialSummariesGetPreviousPaymentsPost$Response(params?: ApiProjectFinancialSummariesGetPreviousPaymentsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetPreviousPaymentsQueryResult>> {
    return apiProjectFinancialSummariesGetPreviousPaymentsPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectFinancialSummariesGetPreviousPaymentsPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectFinancialSummariesGetPreviousPaymentsPost(params?: ApiProjectFinancialSummariesGetPreviousPaymentsPost$Params, context?: HttpContext): Observable<GetPreviousPaymentsQueryResult> {
    return this.apiProjectFinancialSummariesGetPreviousPaymentsPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetPreviousPaymentsQueryResult>): GetPreviousPaymentsQueryResult => r.body)
    );
  }

  /** Path part for operation `apiProjectFinancialSummariesCreateProjectFinancialSummaryPost()` */
  static readonly ApiProjectFinancialSummariesCreateProjectFinancialSummaryPostPath = '/api/ProjectFinancialSummaries/CreateProjectFinancialSummary';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectFinancialSummariesCreateProjectFinancialSummaryPost$Plain()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiProjectFinancialSummariesCreateProjectFinancialSummaryPost$Plain$Response(params?: ApiProjectFinancialSummariesCreateProjectFinancialSummaryPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateProjectFinancialSummaryCommandResult>> {
    return apiProjectFinancialSummariesCreateProjectFinancialSummaryPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectFinancialSummariesCreateProjectFinancialSummaryPost$Plain$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiProjectFinancialSummariesCreateProjectFinancialSummaryPost$Plain(params?: ApiProjectFinancialSummariesCreateProjectFinancialSummaryPost$Plain$Params, context?: HttpContext): Observable<CreateProjectFinancialSummaryCommandResult> {
    return this.apiProjectFinancialSummariesCreateProjectFinancialSummaryPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateProjectFinancialSummaryCommandResult>): CreateProjectFinancialSummaryCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectFinancialSummariesCreateProjectFinancialSummaryPost()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiProjectFinancialSummariesCreateProjectFinancialSummaryPost$Response(params?: ApiProjectFinancialSummariesCreateProjectFinancialSummaryPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateProjectFinancialSummaryCommandResult>> {
    return apiProjectFinancialSummariesCreateProjectFinancialSummaryPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectFinancialSummariesCreateProjectFinancialSummaryPost$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiProjectFinancialSummariesCreateProjectFinancialSummaryPost(params?: ApiProjectFinancialSummariesCreateProjectFinancialSummaryPost$Params, context?: HttpContext): Observable<CreateProjectFinancialSummaryCommandResult> {
    return this.apiProjectFinancialSummariesCreateProjectFinancialSummaryPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateProjectFinancialSummaryCommandResult>): CreateProjectFinancialSummaryCommandResult => r.body)
    );
  }

  /** Path part for operation `apiProjectFinancialSummariesChangeStatusOfProjectFinancialSummaryPost()` */
  static readonly ApiProjectFinancialSummariesChangeStatusOfProjectFinancialSummaryPostPath = '/api/ProjectFinancialSummaries/ChangeStatusOfProjectFinancialSummary';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectFinancialSummariesChangeStatusOfProjectFinancialSummaryPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectFinancialSummariesChangeStatusOfProjectFinancialSummaryPost$Plain$Response(params?: ApiProjectFinancialSummariesChangeStatusOfProjectFinancialSummaryPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ChangeStatusOfProjectFinancialSummaryCommandResult>> {
    return apiProjectFinancialSummariesChangeStatusOfProjectFinancialSummaryPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectFinancialSummariesChangeStatusOfProjectFinancialSummaryPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectFinancialSummariesChangeStatusOfProjectFinancialSummaryPost$Plain(params?: ApiProjectFinancialSummariesChangeStatusOfProjectFinancialSummaryPost$Plain$Params, context?: HttpContext): Observable<ChangeStatusOfProjectFinancialSummaryCommandResult> {
    return this.apiProjectFinancialSummariesChangeStatusOfProjectFinancialSummaryPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ChangeStatusOfProjectFinancialSummaryCommandResult>): ChangeStatusOfProjectFinancialSummaryCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectFinancialSummariesChangeStatusOfProjectFinancialSummaryPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectFinancialSummariesChangeStatusOfProjectFinancialSummaryPost$Response(params?: ApiProjectFinancialSummariesChangeStatusOfProjectFinancialSummaryPost$Params, context?: HttpContext): Observable<StrictHttpResponse<ChangeStatusOfProjectFinancialSummaryCommandResult>> {
    return apiProjectFinancialSummariesChangeStatusOfProjectFinancialSummaryPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectFinancialSummariesChangeStatusOfProjectFinancialSummaryPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectFinancialSummariesChangeStatusOfProjectFinancialSummaryPost(params?: ApiProjectFinancialSummariesChangeStatusOfProjectFinancialSummaryPost$Params, context?: HttpContext): Observable<ChangeStatusOfProjectFinancialSummaryCommandResult> {
    return this.apiProjectFinancialSummariesChangeStatusOfProjectFinancialSummaryPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<ChangeStatusOfProjectFinancialSummaryCommandResult>): ChangeStatusOfProjectFinancialSummaryCommandResult => r.body)
    );
  }

  /** Path part for operation `apiProjectFinancialSummariesUpdateProjectFinancialSummaryPatch()` */
  static readonly ApiProjectFinancialSummariesUpdateProjectFinancialSummaryPatchPath = '/api/ProjectFinancialSummaries/UpdateProjectFinancialSummary';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectFinancialSummariesUpdateProjectFinancialSummaryPatch$Plain()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiProjectFinancialSummariesUpdateProjectFinancialSummaryPatch$Plain$Response(params?: ApiProjectFinancialSummariesUpdateProjectFinancialSummaryPatch$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateProjectFinancialSummaryCommandResult>> {
    return apiProjectFinancialSummariesUpdateProjectFinancialSummaryPatch$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectFinancialSummariesUpdateProjectFinancialSummaryPatch$Plain$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiProjectFinancialSummariesUpdateProjectFinancialSummaryPatch$Plain(params?: ApiProjectFinancialSummariesUpdateProjectFinancialSummaryPatch$Plain$Params, context?: HttpContext): Observable<UpdateProjectFinancialSummaryCommandResult> {
    return this.apiProjectFinancialSummariesUpdateProjectFinancialSummaryPatch$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdateProjectFinancialSummaryCommandResult>): UpdateProjectFinancialSummaryCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectFinancialSummariesUpdateProjectFinancialSummaryPatch()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiProjectFinancialSummariesUpdateProjectFinancialSummaryPatch$Response(params?: ApiProjectFinancialSummariesUpdateProjectFinancialSummaryPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateProjectFinancialSummaryCommandResult>> {
    return apiProjectFinancialSummariesUpdateProjectFinancialSummaryPatch(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectFinancialSummariesUpdateProjectFinancialSummaryPatch$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiProjectFinancialSummariesUpdateProjectFinancialSummaryPatch(params?: ApiProjectFinancialSummariesUpdateProjectFinancialSummaryPatch$Params, context?: HttpContext): Observable<UpdateProjectFinancialSummaryCommandResult> {
    return this.apiProjectFinancialSummariesUpdateProjectFinancialSummaryPatch$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdateProjectFinancialSummaryCommandResult>): UpdateProjectFinancialSummaryCommandResult => r.body)
    );
  }

  /** Path part for operation `apiProjectFinancialSummariesDeleteProjectFinancialSummaryDelete()` */
  static readonly ApiProjectFinancialSummariesDeleteProjectFinancialSummaryDeletePath = '/api/ProjectFinancialSummaries/DeleteProjectFinancialSummary';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectFinancialSummariesDeleteProjectFinancialSummaryDelete$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectFinancialSummariesDeleteProjectFinancialSummaryDelete$Plain$Response(params?: ApiProjectFinancialSummariesDeleteProjectFinancialSummaryDelete$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteProjectFinancialSummaryCommandResult>> {
    return apiProjectFinancialSummariesDeleteProjectFinancialSummaryDelete$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectFinancialSummariesDeleteProjectFinancialSummaryDelete$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectFinancialSummariesDeleteProjectFinancialSummaryDelete$Plain(params?: ApiProjectFinancialSummariesDeleteProjectFinancialSummaryDelete$Plain$Params, context?: HttpContext): Observable<DeleteProjectFinancialSummaryCommandResult> {
    return this.apiProjectFinancialSummariesDeleteProjectFinancialSummaryDelete$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeleteProjectFinancialSummaryCommandResult>): DeleteProjectFinancialSummaryCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectFinancialSummariesDeleteProjectFinancialSummaryDelete()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectFinancialSummariesDeleteProjectFinancialSummaryDelete$Response(params?: ApiProjectFinancialSummariesDeleteProjectFinancialSummaryDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteProjectFinancialSummaryCommandResult>> {
    return apiProjectFinancialSummariesDeleteProjectFinancialSummaryDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectFinancialSummariesDeleteProjectFinancialSummaryDelete$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectFinancialSummariesDeleteProjectFinancialSummaryDelete(params?: ApiProjectFinancialSummariesDeleteProjectFinancialSummaryDelete$Params, context?: HttpContext): Observable<DeleteProjectFinancialSummaryCommandResult> {
    return this.apiProjectFinancialSummariesDeleteProjectFinancialSummaryDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeleteProjectFinancialSummaryCommandResult>): DeleteProjectFinancialSummaryCommandResult => r.body)
    );
  }

}
